import './style.scss';

// Slider - Library import example
import { tns } from "tiny-slider"

document.addEventListener( 'DOMContentLoaded', () => {
	// Copyright year
	document.querySelectorAll( '.copyright' ).forEach( ( div ) => {
		div.innerHTML = div.innerHTML.replace( "{{YEAR}}", new Date().getFullYear() );
	} );

	// Lazy load fade in
	document.querySelectorAll( 'img[loading="lazy"]' ).forEach( ( img ) => {
		if( img.complete === true ) {
			img.classList.add( 'has-loaded' );
		}
		img.addEventListener( "load", ( e ) => {
			e.target.classList.add( 'has-loaded' );
		} );
	} );

	// Sliding items
	document.querySelectorAll( '.wp-block-query.is-style-slider-3x' ).forEach( ( slideContainer ) => {
		const slideOuter = slideContainer.querySelector( '.wp-block-post-template' );
		if( slideOuter ) {
			const tnSlider = tns( {
				container: slideOuter,
				controls: false,
				navPosition: "bottom",
				slideBy: 'page',
				loop: false,
				gap: 20,
				items: 1,
				responsive: {
					640: {
						gutter: 20,
						items: 2
					},
					900: {
						items: 3
					}
				}
			} );
		}
	} );

	document.querySelectorAll( '.wp-block-group.is-style-slider-3x' ).forEach( ( slideContainer ) => {
		const tnSlider = tns( {
			container: slideContainer,
			controls: false,
			navPosition: "bottom",
			slideBy: 'page',
			loop: false,
			gap: 9,
			items: 1,
			responsive: {
				640: {
					gutter: 9,
					items: 2
				},
				900: {
					items: 3
				}
			}
		} );
	} );

	document.querySelectorAll( '.wp-block-group.is-style-slider-3x-arrows' ).forEach( ( slideContainer ) => {
		const tnSlider = tns( {
			container: slideContainer,
			controls: true,
			controlsPosition: "bottom",
			controlsText: ["", ""],
			nav: false,
			navPosition: "bottom",
			slideBy: 'page',
			loop: false,
			gap: 9,
			items: 1,
			responsive: {
				640: {
					gutter: 9,
					items: 2
				},
				900: {
					items: 3
				}
			}
		} );
	} );
	
} );